/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 内容タグアクセス権がファイルポータルでREAD or READ_WRITEの拡張属性のみを返却するかどうかのフラグ - FILTER:内容タグアクセス権で絞る - NON_FILTER:内容タグアクセス権で絞らない 
 * @export
 * @enum {string}
 */

export const ContentTagServiceAccessPermissionQuery = {
    Filter: 'FILTER',
    NonFilter: 'NON_FILTER'
} as const;

export type ContentTagServiceAccessPermissionQuery = typeof ContentTagServiceAccessPermissionQuery[keyof typeof ContentTagServiceAccessPermissionQuery];



